export enum BackgroundColor {
  BLACK = "black",
  GREY = "grey",
}
